import sideSetScope from './sideSetScope.vue'
export default sideSetScope
